import actions from "./actions";
import { sagaReducer } from "../helper";

const initState = {
    partner: null,
    clients: [],
    client: {
        id: null,
    },
    billingEstimate: {
        subscription_total: null,
        discount_rate: null,
        total_discount_amount: null,
        total_after_discount: null,
        plans_with_no_discount_count: null,
        plans_with_no_discount_total: null,
    },
    readBillingEstimateState: null,
    referrals: [],
    transactions: [],
    advisor: {},
    advisors: [],
    events: [],
    eventsPagination: null,
    readState: null,
    updatePaymentMethodState: null,
    deletePaymentMethodState: null,
    updatePartnerProfileState: null,
    pagination: {},
    createClientState: null,
    readClientsState: null,
    readClientState: null,
    readReferralsState: null,
    readTransactionsState: null,
    readEventsState: null,
    changeSubscriptionState: null,
    cancelSubscriptionState: null,
    requestToTransferState: null,
    subscribeSubscriptionState: null,
    readSwitchPlanInfoState: null,
    clientFormDesigns: [],
    clientAccesses: [],
    clientDeleteState: null,
    readAdvisorsState: null,
    createAdvisorState: null,
    readAdvisorState: null,
    updateAdvisorState: null,
    deleteAdvisorState: null,
    advisorCreateResult: {},
};

function getReadStateKey(action) {
    switch (action.type) {
        case actions.PARTNER_READ_REQUEST:
        case actions.PARTNER_READ_SUCCESS:
        case actions.PARTNER_READ_ERROR:
            return 'readState';
        case actions.PARTNER_UPDATE_PAYMENT_METHOD_REQUEST:
        case actions.PARTNER_UPDATE_PAYMENT_METHOD_SUCCESS:
        case actions.PARTNER_UPDATE_PAYMENT_METHOD_ERROR:
            return 'updatePaymentMethodState';
        case actions.PARTNER_DELETE_PAYMENT_METHOD_REQUEST:
        case actions.PARTNER_DELETE_PAYMENT_METHOD_SUCCESS:
        case actions.PARTNER_DELETE_PAYMENT_METHOD_ERROR:
            return 'deletePaymentMethodState';
        case actions.PARTNER_UPDATE_PARTNER_PROFILE_REQUEST:
        case actions.PARTNER_UPDATE_PARTNER_PROFILE_SUCCESS:
        case actions.PARTNER_UPDATE_PARTNER_PROFILE_ERROR:
            return 'updatePartnerProfileState';
        case actions.PARTNER_CREATE_CLIENT_REQUEST:
        case actions.PARTNER_CREATE_CLIENT_SUCCESS:
        case actions.PARTNER_CREATE_CLIENT_ERROR:
            return 'createClientState';
        case actions.PARTNER_READ_CLIENTS_REQUEST:
        case actions.PARTNER_READ_CLIENTS_SUCCESS:
        case actions.PARTNER_READ_CLIENTS_ERROR:
            return 'readClientsState';
        case actions.PARTNER_READ_CLIENT_REQUEST:
        case actions.PARTNER_READ_CLIENT_SUCCESS:
        case actions.PARTNER_READ_CLIENT_ERROR:
            return 'readClientState';
        case actions.PARTNER_READ_REFERRALS_REQUEST:
        case actions.PARTNER_READ_REFERRALS_SUCCESS:
        case actions.PARTNER_READ_REFERRALS_ERROR:
            return 'readReferralsState';
        case actions.PARTNER_READ_BILLING_ESTIMATE_REQUEST:
        case actions.PARTNER_READ_BILLING_ESTIMATE_SUCCESS:
        case actions.PARTNER_READ_BILLING_ESTIMATE_ERROR:
            return 'readBillingEstimateState';
        case actions.PARTNER_READ_TRANSACTIONS_REQUEST:
        case actions.PARTNER_READ_TRANSACTIONS_SUCCESS:
        case actions.PARTNER_READ_TRANSACTIONS_ERROR:
            return 'readTransactionsState';
        case actions.PARTNER_READ_EVENTS_REQUEST:
        case actions.PARTNER_READ_EVENTS_SUCCESS:
        case actions.PARTNER_READ_EVENTS_ERROR:
            return 'readEventsState';
        case actions.PARTNER_CHANGE_SUBSCRIPTION_REQUEST:
        case actions.PARTNER_CHANGE_SUBSCRIPTION_SUCCESS:
        case actions.PARTNER_CHANGE_SUBSCRIPTION_ERROR:
            return 'changeSubscriptionState';
        case actions.PARTNER_CANCEL_SUBSCRIPTION_REQUEST:
        case actions.PARTNER_CANCEL_SUBSCRIPTION_SUCCESS:
        case actions.PARTNER_CANCEL_SUBSCRIPTION_ERROR:
            return 'cancelSubscriptionState';
        case actions.PARTNER_REQUEST_TO_TRANSFER_REQUEST:
        case actions.PARTNER_REQUEST_TO_TRANSFER_SUCCESS:
        case actions.PARTNER_REQUEST_TO_TRANSFER_ERROR:
            return 'requestToTransferState';
        case actions.PARTNER_SUBSCRIBE_SUBSCRIPTION_REQUEST:
        case actions.PARTNER_SUBSCRIBE_SUBSCRIPTION_SUCCESS:
        case actions.PARTNER_SUBSCRIBE_SUBSCRIPTION_ERROR:
            return 'subscribeSubscriptionState';
        case actions.PARTNER_DELETE_CLIENT_REQUEST:
        case actions.PARTNER_DELETE_CLIENT_SUCCESS:
        case actions.PARTNER_DELETE_CLIENT_ERROR:
            return 'clientDeleteState';
        case actions.PARTNER_READ_ADVISORS_REQUEST:
        case actions.PARTNER_READ_ADVISORS_SUCCESS:
        case actions.PARTNER_READ_ADVISORS_ERROR:
            return 'readAdvisorsState';
        case actions.PARTNER_CREATE_ADVISOR_REQUEST:
        case actions.PARTNER_CREATE_ADVISOR_SUCCESS:
        case actions.PARTNER_CREATE_ADVISOR_ERROR:
            return 'createAdvisorState';
        case actions.PARTNER_READ_ADVISOR_REQUEST:
        case actions.PARTNER_READ_ADVISOR_SUCCESS:
        case actions.PARTNER_READ_ADVISOR_ERROR:
            return 'readAdvisorState';
        case actions.PARTNER_UPDATE_ADVISOR_REQUEST:
        case actions.PARTNER_UPDATE_ADVISOR_SUCCESS:
        case actions.PARTNER_UPDATE_ADVISOR_ERROR:
            return 'updateAdvisorState';
        case actions.PARTNER_DELETE_ADVISOR_REQUEST:
        case actions.PARTNER_DELETE_ADVISOR_SUCCESS:
        case actions.PARTNER_DELETE_ADVISOR_ERROR:
            return 'deleteAdvisorState';
        default:
            return false;
    }
}

function reducer(state, action) {
    switch (action.type) {
        case actions.PARTNER_READ_SUCCESS:
            return {
                partner: action.partner,
            };

        case actions.PARTNER_READ_CLIENTS_SUCCESS:
            return {
                clients: action.clients,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };

        case actions.PARTNER_READ_CLIENT_SUCCESS:
            return {
                client: action.client,
            };

        case actions.PARTNER_READ_BILLING_ESTIMATE_SUCCESS:
            return {
                billingEstimate: action.billingEstimate,
            };

        case actions.PARTNER_READ_REFERRALS_SUCCESS:
            return {
                referrals: action.referrals,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };

        case actions.PARTNER_READ_TRANSACTIONS_SUCCESS:
            return {
                transactions: action.transactions,
            };

        case actions.PARTNER_READ_SWITCH_PLAN_INFO_REQUEST:
            return {
                ...state,
                readSwitchPlanInfoState: 'request',
            };
        case actions.PARTNER_READ_SWITCH_PLAN_INFO_SUCCESS:
            return {
                ...state,
                readSwitchPlanInfoState: 'success',
                clientFormDesigns: action.formDesigns,
                clientAccesses: action.accesses,
            };
        case actions.PARTNER_READ_EVENTS_SUCCESS:
            return {
                events: action.events,
                eventsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };

        case actions.PARTNER_READ_ADVISORS_SUCCESS:
            return {
                advisors: action.advisors,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };

        case actions.PARTNER_CREATE_ADVISOR_SUCCESS:
            return {
                advisorCreateResult: action.advisor,
            };

        case actions.PARTNER_INIT_ADVISOR:
        case actions.PARTNER_READ_ADVISOR_SUCCESS:
            return {
                advisor: action.advisor,
            };

        case actions.PARTNER_RESET:
            return initState;

        default:
            return {};
    }
}

export default function mainReducer(state = initState, action = {}) {
    const updatedState = sagaReducer(state, action, getReadStateKey);
    const extra = reducer(state, action);
    return { ...updatedState, ...extra };
}
